import React, {useState} from 'react';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";

/**
 * Save, Remove, Re-map Responses for Question Widgets in Editor Mode
 */
function QAFooter({Widget_ID, handleSave, handleRemove, showRemapResponses,
                      remapResponses, setRemapResponses, verifyRemapResponses}) {

    const [openDialog, setOpenDialog] = useState(false);

    /**
     * If re-map responses option selected, check that certain fields have not been changed before saving.
     * If changed, show a popup that says re-map responses not allowed and
     * allow the user to continue to save without re-mapping responses
     */
    const onSaveClick = () => {
        if (!showRemapResponses || !remapResponses || verifyRemapResponses === undefined || verifyRemapResponses())
            handleSave();
        else
            setOpenDialog(true);
    }

    return (
        <>
            <div className="d-flex justify-content-end align-items-center">
                {showRemapResponses &&
                    <div className='custom-control custom-switch mr-2'>
                        <input
                            className='custom-control-input'
                            type='checkbox'
                            checked={remapResponses}
                            id={'remapResponses' + Widget_ID}
                            onChange={() => setRemapResponses(!remapResponses)}
                        />
                        <label className='custom-control-label' htmlFor={'remapResponses' + Widget_ID}>
                            Re-map responses
                        </label>
                    </div>
                }
                <button
                    className="btn btn-outline-primary m-2"
                    onClick={onSaveClick}
                >
                    Save
                </button>
                <button
                    className="btn btn-outline-danger m-2"
                    onClick={handleRemove}
                >
                    Delete
                </button>
            </div>
            <Dialog
                open={openDialog}
                fullWidth
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Re-map responses not allowed</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Re-mapping responses is not allowed with the changes made.
                        Would you like to proceed to save <b>without</b> re-mapping responses?
                        Any existing responses to this question will be lost.

                        <br/><br/>
                        If re-mapping is needed, please cancel and reach out to the technical team.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-outline-primary rounded-0 btn-sm" onClick={() => {setOpenDialog(false); handleSave()}}>
                        Yes
                    </button>
                    <button className="btn btn-outline-danger rounded-0 btn-sm" onClick={() => setOpenDialog(false)}>
                        Cancel
                    </button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default QAFooter;